import { render, staticRenderFns } from "./RejectCredit.vue?vue&type=template&id=785a86ff&scoped=true&"
import script from "./RejectCredit.vue?vue&type=script&lang=js&"
export * from "./RejectCredit.vue?vue&type=script&lang=js&"
import style0 from "./RejectCredit.vue?vue&type=style&index=0&id=785a86ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a86ff",
  null
  
)

export default component.exports